import { render, staticRenderFns } from "./MotivosAcolhimento.vue?vue&type=template&id=1bade8e2&scoped=true"
import script from "./MotivosAcolhimento.vue?vue&type=script&lang=js"
export * from "./MotivosAcolhimento.vue?vue&type=script&lang=js"
import style0 from "./MotivosAcolhimento.vue?vue&type=style&index=0&id=1bade8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bade8e2",
  null
  
)

export default component.exports